module.exports = __webpack_public_path__ + "assets/img/news-operate.1fa6b55b.png";